import { TrialPeriodState } from "@/types/store/clientzone/trial_period";
import { TrialPeriodData } from "@/types";

export const state: TrialPeriodState = {
  trialPeriod: [] as Array<TrialPeriodData>
}
